module.exports = __webpack_public_path__ + "fonts/suisseintl-book-webfont-webfont.3b1395aeab4ccfa8de921ac334feaad6.woff";